import React from 'react'
import css from './Spinner.module.scss'

const Spinner = ({align}) =>{
	return (
		<div className={css.spinner + ' ' + css[align]}>
			<i/>
		</div>
	)
}

export default Spinner
